export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Wip 6_02.7afca4b5.jpg";